export const COMPENSATION_TYPE_OPTIONS = [
  { label: 'Hourly ($/hour)', value: 'HOUR' },
  { label: 'Per Shift ($/shift)', value: 'SHIFT' },
  { label: 'RVU Based ($/RVU)', value: 'RVU' },
];

export const emptyCompensationForm = {
  compType: COMPENSATION_TYPE_OPTIONS[0],
  pricePerHour: null,
  pricePerShift: null,
  pricePerRvu: null,
  yearlyRvusPerFte: null,
};
